import { Action, createAction, handleActions } from 'redux-actions'
import { END, eventChannel } from 'redux-saga'
import { put } from 'redux-saga-test-plan/matchers'
import { call, take, takeLatest } from 'redux-saga/effects'

import browserHistory from '@/utils/historyUtils'

export const HISTORY = 'History'

const PUSH = `${HISTORY}/Push`
const POP = `${HISTORY}/Back`
const REDIRECT = `${HISTORY}/Redirect`
const SET_PAGING_TRANSITION = `${HISTORY}/setPagingTransition`
const NEXT_PAGING_TRANSITION_OFF = `${HISTORY}/nextPagingTransitionOff`

export interface IHistoryState {
  histories: string[]
  pagingTransition: boolean
}

export const historyActions = {
  push: createAction<string>(PUSH),
  pop: createAction(POP),
  redirect: createAction<string>(REDIRECT),
  setPagingTransition: createAction<boolean>(SET_PAGING_TRANSITION),
  nextPagingTransitionOff: createAction(NEXT_PAGING_TRANSITION_OFF),
}

const initialState: IHistoryState = {
  histories: [],
  pagingTransition: true,
}

export const reducer = {
  [PUSH](state: IHistoryState, action: Action<string>) {
    state.histories.push(action.payload)

    return {
      ...state,
    }
  },
  [POP](state: IHistoryState) {
    if (state.histories.length > 0) {
      state.histories.pop()
    }

    return {
      ...state,
    }
  },
  [REDIRECT](state: IHistoryState, action: Action<string>) {
    if (state.histories.length > 0) {
      state.histories[state.histories.length - 1] = action.payload
    }

    return {
      ...state,
    }
  },
  [SET_PAGING_TRANSITION](state: IHistoryState, action: any) {
    return {
      ...state,
      pagingTransition: action.payload,
    }
  },
  [NEXT_PAGING_TRANSITION_OFF](state: IHistoryState) {
    return {
      ...state,
      pagingTransition: false,
    }
  },
}

export const historyReducer = handleActions(reducer, initialState)

function historyListenChannel() {
  return eventChannel(emit => {
    const unlisten = browserHistory.listen(location => {
      emit(location)
      emit(END)
    })

    return () => {
      unlisten()
    }
  })
}

function* nextPagingTransitionOff() {
  const channel = yield call(historyListenChannel)
  yield take(channel)
  yield put(historyActions.setPagingTransition(true))
}

export const historySaga = [takeLatest(NEXT_PAGING_TRANSITION_OFF, nextPagingTransitionOff)]
